import env from '@/config/env'

import spc1212 from '@/assets/images/mock/spc121-2.png'
import AKX10S2 from '@/assets/images/mock/akx10s-2.png'
import MK2002 from '@/assets/images/mock/mk200-2.png'
import MR101S2 from '@/assets/images/mock/mr101s-2.png'
import p1Pic from '@/assets/images/home/banner2.jpg'
import p3Pic from '@/assets/images/temp/p3-1.jpg'
import p4Pic from '@/assets/images/temp/p4-1.png'


import AKX10St1 from '@/assets/images/product/AKX10S/详情页面第一张.png'
import AKX10St2 from '@/assets/images/product/AKX10S/详情第二版块的图.png'
import AKX10St3 from '@/assets/images/product/AKX10S/详情页面卖点图1.jpg'
import AKX10St4 from '@/assets/images/product/AKX10S/详情页面卖点图2.jpg'
import AKX10St5 from '@/assets/images/product/AKX10S/详情页面卖点图3.jpg'
import AKX10St8 from '@/assets/images/product/AKX10S/a.jpg'
import AKX10St9 from '@/assets/images/product/AKX10S/b.jpg'

import CP203t1 from '@/assets/images/product/CP203/详情页面第一张.png'
import CP203t2 from '@/assets/images/product/CP203/详情页面第二张.png'
import CP203t3 from '@/assets/images/product/CP203/详情页面卖点1.jpg'
import CP203t4 from '@/assets/images/product/CP203/详情页面卖点2.jpg'
import CP203t5 from '@/assets/images/product/CP203/详情页面卖点3.jpg'
import CP203t6 from '@/assets/images/product/CP203/a.jpg'
import CP203t7 from '@/assets/images/product/CP203/b.jpg'
import CP203t8 from '@/assets/images/product/CP203/c.jpg'
import CP203t9 from '@/assets/images/product/CP203/d.png'
import CP203t10 from '@/assets/images/product/CP203/e.jpg'

import MK200t1 from '@/assets/images/product/MK200/未标题-2_01.png'
import MK200t2 from '@/assets/images/product/MK200/a.jpg'
import MK200t3 from '@/assets/images/product/MK200/a.jpg'
import MK200D1 from '@/assets/images/product/MK200/放产品详情页面.jpg'
import MK200D2 from '@/assets/images/product/MK200/放产品详情页面1.jpg'
import MK200D3 from '@/assets/images/product/MK200/放产品详情页面3.jpg'
import MK200D4 from '@/assets/images/product/MK200/放产品详情页面4.jpg'
import MK200D5 from '@/assets/images/product/MK200/放产品详情页面5.jpg'
import MK200D6 from '@/assets/images/product/MK200/放产品详情页面6.jpg'
import MK2001 from '@/assets/images/product/MK200/b.jpg'
import MK2003 from '@/assets/images/product/MK200/c.jpg'
import MK2004 from '@/assets/images/product/MK200/d.jpg'
import MK2005 from '@/assets/images/product/MK200/e.png'

import MK37t1 from '@/assets/images/product/MK37/Banner.jpg'
import MK37t2 from '@/assets/images/product/MK37/aa.png'
import MK37t3 from '@/assets/images/product/MK37/导航正面图片.jpg'
import MK37D1 from '@/assets/images/product/MK37/放产品详情页面.jpg'
import MK37D2 from '@/assets/images/product/MK37/放产品详情页面1.jpg'
import MK37D3 from '@/assets/images/product/MK37/放产品详情页面2.jpg'
import MK37D4 from '@/assets/images/product/MK37/放产品详情页面3.jpg'
import MK37D5 from '@/assets/images/product/MK37/放产品详情页面4.jpg'
import MK37D6 from '@/assets/images/product/MK37/放产品详情页面5.jpg'
import MK371 from '@/assets/images/product/MK37/d.jpg'
import MK372 from '@/assets/images/product/MK37/b.jpg'
import MK373 from '@/assets/images/product/MK37/c.jpg'

import MK61t1 from '@/assets/images/product/MK61/未标题-2_01.png'
import MK61t2 from '@/assets/images/product/MK61/未标题-2_04.png'
import MK61t3 from '@/assets/images/product/MK61/首页导航正面图.jpg'
import MK61D1 from '@/assets/images/product/MK61/放产品详情页面.jpg'
import MK61D2 from '@/assets/images/product/MK61/放产品详情页面1.jpg'
import MK61D3 from '@/assets/images/product/MK61/放产品详情页面2.jpg'
import MK61D4 from '@/assets/images/product/MK61/放产品详情页面3.jpg'
import MK61D6 from '@/assets/images/product/MK61/放产品详情页面5.jpg'
import MK611 from '@/assets/images/product/MK61/a.jpg'
import MK612 from '@/assets/images/product/MK61/b.jpg'
import MK613 from '@/assets/images/product/MK61/c.jpg'
import MK614 from '@/assets/images/product/MK61/d.jpg'
import MK615 from '@/assets/images/product/MK61/e.jpg'
import MK616 from '@/assets/images/product/MK61/f.jpg'

import MR1010St1 from '@/assets/images/product/MR1010s/详情页面第一张.png'
import MR1010St2 from '@/assets/images/product/MR1010s/详情页面第二张.png'
import MR1010St3 from '@/assets/images/product/MR1010s/详情页面卖点2.jpg'
import MR1010St4 from '@/assets/images/product/MR1010s/详情页面卖点1.jpg'
import MR1010St5 from '@/assets/images/product/MR1010s/详情页面卖点3.jpg'
import MR1010St6 from '@/assets/images/product/MR1010s/a.jpg'
import MR1010St7 from '@/assets/images/product/MR1010s/b.jpg'
import MR1010St8 from '@/assets/images/product/MR1010s/c.jpg'
import MR1010St9 from '@/assets/images/product/MR1010s/d.png'
import MR1010St10 from '@/assets/images/product/MR1010s/e.jpg'
import MR1010St11 from '@/assets/images/product/MR1010s/f.jpg'
import MR1010St12 from '@/assets/images/product/MR1010s/g.jpg'

import SPC121t1 from '@/assets/images/product/SPC121/详情页面第一张.png'
import SPC121t2 from '@/assets/images/product/SPC121/详情页面第二张.png'
import SPC121t3 from '@/assets/images/product/SPC121/详情页面卖点1.jpg'
import SPC121t4 from '@/assets/images/product/SPC121/详情页面卖点2.jpg'
import SPC121t5 from '@/assets/images/product/SPC121/详情页面卖点3.jpg'
import SPC121t6 from '@/assets/images/product/SPC121/2.jpg'
import SPC121t7 from '@/assets/images/product/SPC121/b.jpg'
import SPC121t8 from '@/assets/images/product/SPC121/c.jpg'
import SPC121t9 from '@/assets/images/product/SPC121/d.jpg'
import SPC121t10 from '@/assets/images/product/SPC121/e.jpg'

import SPC121PLUSt1 from '@/assets/images/product/SP201PLUS/详情页面第一张.png'
import SPC121PLUSt2 from '@/assets/images/product/SP201PLUS/详情页面蒂第二张.png'
import SPC121PLUSt3 from '@/assets/images/product/SP201PLUS/h.jpg'
import SPC121PLUSt4 from '@/assets/images/product/SP201PLUS/详情页面卖点2.png'
import SPC121PLUSt5 from '@/assets/images/product/SP201PLUS/详情页面卖点3.png'
import SPC121PLUSt6 from '@/assets/images/product/SP201PLUS/a.png'
import SPC121PLUSt7 from '@/assets/images/product/SP201PLUS/b.png'
import SPC121PLUSt8 from '@/assets/images/product/SP201PLUS/c.jpg'
import SPC121PLUSt9 from '@/assets/images/product/SP201PLUS/d.jpg'
import SPC121PLUSt10 from '@/assets/images/product/SP201PLUS/e.jpg'

import mk49Banner from '@/assets/images/product/MK49/Banner.jpg'
import MK49p1 from '@/assets/images/product/MK49/p1.png'
import MK49p2 from '@/assets/images/product/MK49/p2.jpg'
import MK49p3 from '@/assets/images/product/MK49/p3.jpg'
import MK49p4 from '@/assets/images/product/MK49/p4.jpg'
import MK49p5 from '@/assets/images/product/MK49/p5.png'

import TP110p1 from '@/assets/images/product/TP110/1.jpg'
import TP110p2 from '@/assets/images/product/TP110/2.jpg'
import TP110p3 from '@/assets/images/product/TP110/3.jpg'
import TP110p4 from '@/assets/images/product/TP110/4.jpg'
import TP110p5 from '@/assets/images/product/TP110/5.jpg'
import TP110p6 from '@/assets/images/product/TP110/6.jpg'
import TP110p9 from '@/assets/images/product/TP110/7.jpg'
import TP110p8 from '@/assets/images/product/TP110/8.jpg'
import TP110p7 from '@/assets/images/product/TP110/9.png'

const AKX10s1Doc = env.docs + '/AKX10s-1.pdf'
const AKX10s2Doc = env.docs + '/AKX10s-2.pdf'
const AKX10s3Doc = env.docs + '/AKX10s-3.pdf'
const AKX10s4Doc = env.docs + '/AKX10S_upgrade_V1.1.4.zip'
const CP203Doc = env.docs + '/CP203.pdf'
const MK37Doc = env.docs + '/MK37.pdf'
const MK61Doc = env.docs + '/MK61.pdf'
const MK49Doc = env.docs + '/MK49.pdf'
const MK200Doc = env.docs + '/MK200.pdf'
const SP201PLUSDoc = env.docs + '/SP201PLUS.pdf'
const SPC121Doc = env.docs + '/SPC-121.pdf'
const TP110Doc = env.docs + '/TP110.pdf'

export const productMap = {
  SPC121: {
    title: 'SP-C121',
    id: 'SPC121',
    pic: SPC121t2,
    pic2: SPC121t1,
    video: 'https://medeli-us.com/video/SP121.mp4',
    docs: [{href: SPC121Doc, size: '0.8MB', afterfix: "OWNER'S MANUAL"}],
    desc: 'The Medeli SP-C121 offers acoustic piano feel and sound in a compact, portable design. Built for serious beginners and intermediate players, SPC121 can be accessorized for home, or stay travel ready to make music anywhere.',
    sp1: {
      text: 'The 88-key Graded Action Compact (GAC) full sized, touch-sensitive weighted keyboard helps build proper finger strength and achieve dynamic musical expression.',
      pic: SPC121t6
    },
    sp2: {
      text: 'The powerful built-in stereo sound system fills the room with crystal clear musical joy.',
      pic: SPC121t7
    },
    sp3: {
      text: 'The celebrated ‘German Grand’ piano sound delivers a rich and detailed concert grand experience, and its natural timbre is well suited for any genre.',
      pic: SPC121t8
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: SPC121t1, desc: '20 onboard instrument Sounds include pianos, organs, and more, giving you the freedom to choose the right sound for the music you play.' },
      { title: 'SELLING POINT 2', pic: SPC121t9, desc: 'The built-in USB MIDI and Audio interface means with only one cable your SP-C121 can connect with PCs or smart devices to interact with various learning or creative apps. Record to your software and listen back through the instrument’s speakers or headphones. ' },
      { title: 'SELLING POINT 3', pic: SPC121t5, desc: 'A dedicated Line Output connector lets you easily connect your SP-C121 to external amplification or studio equipment for live performances or recording.' },
      { title: 'SELLING POINT 4', pic: SPC121t4, desc: 'Dual headphone jacks allow for private practice, duets, or lessons with a partner.' },
      { title: 'SELLING POINT 5', pic: SPC121t10, desc: 'Matching stands, pedals, and benches can be added, turning your SP-C121 into a slim, modern furniture style instrument that complements the décor of any room.' }
    ],
    banners: [{pic: SPC121t1}, {pic: SPC121t3}, {pic: SPC121t4}, {pic: SPC121t5}],
    params: [
      {label: 'KEYBOARD', value: '88 keys (graded hammer action)'},
      {label: 'DISPLAY', value: ''},
      {label: 'MAX POLYPHONY', value: '64'},
      {label: 'SOUND / VOICE', value: '20'},
      {label: 'STYLE', value: ''},
      {label: 'DEMO SONG', value: '1 piano • 20 sound demo'},
      {label: 'MUSIC LIBRARY', value: '10 songs'},
      {label: 'LAYER / SPLIT', value: 'L • R1 • R2'},
      {label: 'DUO (TWINOVA) ', value: 'Yes'},
      {label: 'STYLE CONTROL', value: ''},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: ''},
      {label: 'REVERB', value: '10 levels'},
      {label: 'CHORUS', value: ''},
      {label: 'EFFECT', value: 'D.A.S.'},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: ''},
      {label: 'SEQUENCER', value: ''},
      {label: 'PERFORMANCE MEMORY', value: ''},
      {label: 'Q.S. / O.T.S.', value: ''},
      {label: 'PERFORMANCE ENHANCEMENT', value: ''},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: ''},
      {label: 'PITCH ADJUSTMENT', value: ['Transpose', 'Octave']},
      {label: 'METRONOME', value: '0 • 2-6'},
      {label: 'TEMPO', value: '5-320 • Tap tempo'},
      {label: 'OTHER CONTROL', value: ['Touch sensitive']},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-B (MIDI & Audio)'},
      {label: 'MIDI', value: 'MIDI out'},
      {label: 'Headphone jack', value: '1 x 1/4" • 1 x 1/8"'},
      {label: 'Input jack', value: '1 x 1/8"'},
      {label: 'Output jack', value: '1 x 1/4"'},
      {label: 'Microphone jack', value: ''},
      {label: 'Pedal', value: 'Unit • Sustain'},
      {label: 'AMPLIFIER', value: '2 x 25 watt'},
      {label: 'SPEAKER', value: '2 x (16 x 7) cm oval'},
      {label: 'POWER', value: 'DC 12V'},
      {label: 'DIMENSIONS', value: '51.57 x 11.57 x 4.88 in / 1310 x 294 x 124 mm'},
      {label: 'WEIGHT', value: '26.24 lb / 11.9 kg'},
      {label: 'AVAILABLE COLOR', value: 'BK, WH'},
    ]
  },
  SP201Plus: {
    title: 'SP201 PLUS',
    id: 'SP201Plus',
    pic: SPC121PLUSt2,
    pic2: SPC121PLUSt10,
    video: 'https://medeli-us.com/video/SP201Plus.mp4',
    docs: [{href: SP201PLUSDoc, size: '0.2MB', afterfix: "OWNER'S MANUAL"}],
    desc: 'The Medeli SP201 Plus gives experienced pianists and casual performers all the essentials in a stylish and portable package.',
    sp1: {
      text: 'Two world-class concert grands are at your service: The ‘German Grand’ and ‘Japanese Grand’ pianos offer distinct tonal qualities that apply beautifully to all musical genres.',
      pic: SPC121PLUSt3
    },
    sp2: {
      text: 'The 88-key Graded Action Standard II (GAS-II) full sized, touch-sensitive weighted keyboard provides authentic acoustic piano feel and musical expression. ',
      pic: SPC121PLUSt4
    },
    sp3: {
      text: 'The powerful bi-amped stereo speaker system delivers clear and detailed sound that brings your music to life.',
      pic: SPC121PLUSt5
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: SPC121PLUSt6, desc: '30 stunning instrument Sounds include pianos, organs, and more, that fuel your creativity and add sonic flavor to the music you play. ' },
      // { title: 'SELLING POINT 2', pic: SPC121PLUSt4, desc: 'The built-in USB MIDI and Audio interface provides seamless interaction with various learning or creative apps on your PC or smart device. ' },
      { title: 'SELLING POINT 3', pic: SPC121PLUSt7, desc: 'Bluetooth MIDI allows for wireless connection to the Piano Toolbox app for intuitive, visual control over the instrument’s settings and functions.' },
      { title: 'SELLING POINT 4', pic: SPC121PLUSt8, desc: 'The built-in USB MIDI and Audio interface provides seamless interaction with various learning or creative apps on your PC or smart device.A dedicated Line Output connector lets you easily connect your SP201 Plus to external amplification or studio equipment for live performances or recording.' },
      { title: 'SELLING POINT 5', pic: SPC121PLUSt4, desc: '50 drum rhythms are at your fingertips to enhance your performances or make practice sessions more fun.' },
      { title: 'SELLING POINT 6', pic: SPC121PLUSt5, desc: 'Record your performances with the built-in song recorder to help you improve your playing, or simply enjoy listening to what you created.' },
      { title: 'SELLING POINT 7', pic: SPC121PLUSt9, desc: 'Accessorize your SP201 Plus with the matching stand and pedal package, and a padded wooden bench for a beautifully modern look that complements any room.' },
    ],
    banners: [{pic: SPC121PLUSt1}, {pic: SPC121PLUSt3}, {pic: SPC121PLUSt4}, {pic: SPC121PLUSt5}],
    params: [
      {label: 'KEYBOARD', value: '88 keys (graded hammer action)'},
      {label: 'DISPLAY', value: ''},
      {label: 'MAX POLYPHONY', value: '192'},
      {label: 'SOUND / VOICE', value: '30'},
      {label: 'STYLE', value: '50'},
      {label: 'DEMO SONG', value: ''},
      {label: 'MUSIC LIBRARY', value: '100 songs'},
      {label: 'LAYER / SPLIT', value: 'L • R1 • R2'},
      {label: 'DUO (TWINOVA) ', value: 'Yes'},
      {label: 'STYLE CONTROL', value: ['Start / Stop', 'Accomp volume']},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: ''},
      {label: 'REVERB', value: '2 types • 10 levels'},
      {label: 'CHORUS', value: '1 type • 10 levels'},
      {label: 'EFFECT', value: 'D.A.S.'},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: ''},
      {label: 'SEQUENCER', value: '1 user song'},
      {label: 'PERFORMANCE MEMORY', value: ''},
      {label: 'Q.S. / O.T.S.', value: ''},
      {label: 'PERFORMANCE ENHANCEMENT', value: ''},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: ''},
      {label: 'PITCH ADJUSTMENT', value: ['Transpose', 'Octave', 'Tuning', 'Scale tuning']},
      {label: 'METRONOME', value: 'Yes (rhythm pattern)'},
      {label: 'TEMPO', value: '5-320'},
      {label: 'OTHER CONTROL', value: ['Touch sensitive', 'Brilliance', 'Piano parameters', 'PianoToolbox (iOS & Android)', 'Local control']},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: 'MIDI'},
      {label: 'USB', value: '1 x USB-B (MIDI & Audio)'},
      {label: 'MIDI', value: 'MIDI out'},
      {label: 'Headphone jack', value: '1 x 1/4" • 1 x 1/8"'},
      {label: 'Input jack', value: '1 x 1/8"'},
      {label: 'Output jack', value: '1 x 1/4"'},
      {label: 'Microphone jack', value: ''},
      {label: 'Pedal', value: 'Unit • Sustain'},
      {label: 'AMPLIFIER', value: '2 x 20 watt'},
      {label: 'SPEAKER', value: '2 x (16 x 7) cm oval • 2 x 3 cm'},
      {label: 'POWER', value: 'DC 12V'},
      {label: 'DIMENSIONS', value: '53.74 x 14.41 x 5.28 in / 1365 x 366 x 134 mm'},
      {label: 'WEIGHT', value: '27.56 lb / 12.5 kg'},
      {label: 'AVAILABLE COLOR', value: 'BK, WH'},
    ]
  },
  CP203: {
    title: 'CP203',
    id: 'CP203',
    pic: CP203t2,
    pic2: CP203t1,
    video: 'https://medeli-us.com/video/CP203.mp4',
    docs: [{href: CP203Doc, size: '0.7MB', afterfix: "OWNER'S MANUAL"}],
    desc: 'The Medeli CP203 is beautiful sounding, modern looking with a compact design, making it an ideal choice for pianists of all abilities who are concerned about saving space.',
    sp1: {
      text: 'The 88-key Graded Action Compact (GAC) full sized, touch-sensitive weighted keyboard helps build proper finger strength and achieve dynamic musical expression. ',
      pic: CP203t6
    },
    sp2: {
      text: '30 stunning instrument Sounds including pianos, organs, and more, fueling your creativity and adding sonic flavor to the music you play.',
      pic: CP203t9
    },
    sp3: {
      text: 'Two world-class concert grands are at your service: The ‘German Grand’ and ‘Japanese Grand’ pianos offer distinct tonal qualities that apply beautifully to all musical genres.',
      pic: CP203t10
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: CP203t1, desc: 'The powerful bi-amped stereo speaker system delivers clear and detailed sound that brings your music to life. ' },
      { title: 'SELLING POINT 2', pic: CP203t3, desc: '50 built-in drum rhythms add variety to your practice sessions and liven up the songs you play for fun. ' },
      { title: 'SELLING POINT 3', pic: CP203t8, desc: 'USB MIDI makes connecting with learning and creative apps on your PC or smart device simple and easy. Connect to the Piano Toolbox app to make selecting sounds and configuring settings even more intuitive. ' },
      { title: 'SELLING POINT 4', pic: CP203t7, desc: 'Dual headphone jacks allow for private practice, duets, or lessons with a partner.' },
    ],
    banners: [{pic: CP203t1}, {pic: CP203t3}, {pic: CP203t4}, {pic: CP203t5}],
    params: [
      {label: 'KEYBOARD', value: '88 keys (graded hammer action)'},
      {label: 'DISPLAY', value: ''},
      {label: 'MAX POLYPHONY', value: '192'},
      {label: 'SOUND / VOICE', value: '30'},
      {label: 'STYLE', value: '50'},
      {label: 'DEMO SONG', value: ''},
      {label: 'MUSIC LIBRARY', value: '100 piano songs'},
      {label: 'LAYER / SPLIT', value: 'L • R1 • R2'},
      {label: 'DUO (TWINOVA) ', value: 'Yes'},
      {label: 'STYLE CONTROL', value: ['Start / Stop', ' Accomp volume']},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: ''},
      {label: 'REVERB', value: '2 types  • 10 levels'},
      {label: 'CHORUS', value: '10 levels'},
      {label: 'EFFECT', value: 'D.A.S.'},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: ''},
      {label: 'SEQUENCER', value: '1 user song'},
      {label: 'PERFORMANCE MEMORY', value: ''},
      {label: 'Q.S. / O.T.S.', value: ''},
      {label: 'PERFORMANCE ENHANCEMENT', value: ''},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: ''},
      {label: 'PITCH ADJUSTMENT', value: ['Transpose', 'Octave', 'Tuning', 'Scale tuning']},
      {label: 'METRONOME', value: 'Yes (rhythm pattern)'},
      {label: 'TEMPO', value: '5-320'},
      {label: 'OTHER CONTROL', value: ['Touch sensitive', 'Brilliance', 'Piano parameters', 'PianoToolbox (iOS & Android)']},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-B (MIDI & Audio)'},
      {label: 'MIDI', value: 'MIDI out'},
      {label: 'Headphone jack', value: '1 x 1/4" • 1 x 1/8"'},
      {label: 'Input jack', value: '1 x 1/8"'},
      {label: 'Output jack', value: '1 x 1/4"'},
      {label: 'Microphone jack', value: ''},
      {label: 'Pedal', value: '(soft / sostenuto / sustain)'},
      {label: 'AMPLIFIER', value: '2 x 20 watt'},
      {label: 'SPEAKER', value: '2 x 6 cm •  2 x 12 cm'},
      {label: 'POWER', value: 'DC 12V'},
      {label: 'DIMENSIONS', value: '53.39 x 11.73 x 31.02 in / 1356 x 298 x 788 mm'},
      {label: 'WEIGHT', value: '89.29 lb / 40.5 kg'},
      {label: 'AVAILABLE COLOR', value: 'NB,NW'},
    ]
  },
  AKX10S: {
    title: 'AKX10S',
    id: 'AKX10S',
    pic: AKX10St2,
    pic2: AKX10St9,
    video: 'https://medeli-us.com/video/AKX10s.mp4',
    docs: [
      {href: AKX10s1Doc, size: '0.6M', afterfix: "DATA LIST"}, 
      {href: AKX10s2Doc, size: '10MB', afterfix: "OWNER'S MANUAL"}, 
      {href: AKX10s3Doc, size: '2.3MB', afterfix: "QUICK START"},
      {href: AKX10s4Doc, size: '10MB', afterfix: 'FIRMWARE'}
    ],
    desc: 'The Medeli AKX10S arranger keyboard is the perfect companion for solo entertainers who want to perform their favorite music and sound like a full band. Songwriters also enjoy this full-featured instrument for its complete instrumental arrangements that follow the chords you play, no matter what music genre you choose.',
    sp1: {
      text: 'Featuring a 7” color touch screen, the intuitive user interface gives you complete control of your backing band and the sounds you play. ',
      pic: AKX10St3
    },
    sp2: {
      text: '300 built-in accompaniment styles span a wide range of musical genres, letting you sound like your favorite recordings or create your own unique genre-bending versions. There is also room for up to 1000 user styles so you can expand and customize your style library to your needs. ',
      pic: AKX10St4
    },
    sp3: {
      text: '1133 instrument Sounds are at your fingertips to choose the perfect tones for your tunes. Imagine the creative possibilities!',
      pic: AKX10St5
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: AKX10St1, desc: 'Assignable knobs, buttons, pedals and other controllers let you customize the way you interact with your music in real time. ' },
      { title: 'SELLING POINT 2', pic: AKX10St3, desc: '768MB of expansion memory is ready for you to add new Sounds to your AKX10S, making it even more of a perfect partner for your musical endeavors. ' },
      { title: 'SELLING POINT 3', pic: AKX10St8, desc: 'The 16-track on-board sequencer gives you flexibility when recording your personal backing band all at once, or when adding your parts one by one. Edit, mix and apply effects until your song is just right.' },
      { title: 'SELLING POINT 4', pic: AKX10St5, desc: 'Connect a microphone and hear your voice with professional studio effects applied, through the instrument’s powerful built-in speakers, or record directly to a USB storage device.' },
      { title: 'SELLING POINT 5', pic: AKX10St1, desc: ' Connect to studio equipment or external amplification via Line Outputs, use USB or MIDI cables to interface with other digital instruments and computers, or even go wireless with Bluetooth MIDI and audio. ' },
      { title: 'SELLING POINT 6', pic: AKX10St3, desc: 'GrandSuite V2 companion software gives you the power to create and edit Styles and Sounds, install expansion packs, import SF2 (SoundFont2) sounds and more. ' },
      { title: 'SELLING POINT 7', pic: AKX10St4, desc: 'Breathe Light into your live performance through customizable LEDs that pulse in time with your music.' },
    ],
    banners: [{pic: AKX10St1}, {pic: AKX10St3}, {pic: AKX10St4}, {pic: AKX10St5}],
    params: [
      {label: 'KEYBOARD', value: '61 keys (touch-sensitive)'},
      {label: 'DISPLAY', value: '7" touch screen'},
      {label: 'MAX POLYPHONY', value: '256'},
      {label: 'SOUND / VOICE', value: '1133 + 256 GM2 + 500 users (max)'},
      {label: 'STYLE', value: '300 + 1000 users (max.)'},
      {label: 'DEMO SONG', value: '3'},
      {label: 'MUSIC LIBRARY', value: [' 3 songs', 'Album (126 + 1000 users max.)']},
      {label: 'LAYER / SPLIT', value: 'L • R1 • R2 • R3'},
      {label: 'DUO (TWINOVA) ', value: ''},
      {label: 'STYLE CONTROL', value: [
        'Start / Stop',
        'Sync start',
        'Sync stop',
        'Intro 1',
        'Intro 2',
        'Intro 3',
        'Ending 1',
        'Ending 2',
        'Ending 3',
        'Main A / Fill in A',
        'Main B / Fill in B',
        'Main C / Fill in C',
        'Main D / Fill in D',
        'Break',
        'Auto fill in',
        'Chord on / off',
        'Fade in / out',
        'Q.S. link'
      ]},
      {label: 'STYLE CREATOR', value: 'Yes'},
      {label: 'CHORD TYPE', value: '39'},
      {label: 'REVERB', value: '45 types • 30 users'},
      {label: 'CHORUS', value: '76 types • 30 users'},
      {label: 'EFFECT', value: [
        'Channel EQ',
        'Compressor',
        'D.A.S.',
        'IFX (48 presets + 30 users)',
        'Mic effects (EQ, compressor, 47 DSP effects, 3 vocoder, 3 vocal harmony)'
      ]},
      {label: 'MASTER EQ', value: '5 + 30 users'},
      {label: 'MIXER', value: 'Yes'},
      {label: 'SEQUENCER', value: '500 user songs (max.)(16 tracks)'},
      {label: 'PERFORMANCE MEMORY', value: '8 x 200 banks • Lock'},
      {label: 'Q.S. / O.T.S.', value: 'Yes'},
      {label: 'PERFORMANCE ENHANCEMENT', value: ['Arpeggiator', 'Harmony', 'Slicer']},
      {label: 'AUDIO PLAYBACK', value: ['MP3 • WAV • AAC', 'Vocal remover', 'Audio tempo', 'Audio transpose']},
      {label: 'AUDIO RECORDER', value: 'MP3 • WAV (44.1KHz / 16 bit)'},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ['2 x pedals', ' 3 x knobs','3 x switches', '1 x joystick']},
      {label: 'PITCHBEND', value: 'Yes'},
      {label: 'MODULATION', value: 'Yes'},
      {label: 'PITCH ADJUSTMENT', value: [
        'Transpose',
        'Octave',
        'Tuning',
        'Scale tuning (9 + 30 users)'
      ]},
      {label: 'METRONOME', value: 'Yes'},
      {label: 'TEMPO', value: '5-320 • Tap tempo'},
      {label: 'OTHER CONTROL', value: [
        'Touch sensitive',
        'Sustain',
        'Chord reference',
        'Sound edit',
        'Phrase pad  (4 x 180 banks + 500 users max.)',
        'Internal storage (approx. 768MB sample expansion)'
      ]},
      {label: 'EXTERNAL DRIVE', value: 'USB (512GB max.)'},
      {label: 'Bluetooth', value: 'MIDI & Audio'},
      {label: 'USB', value: ['1 x USB-A (Device)', '1 x USB-B (MIDI & Audio)']},
      {label: 'MIDI', value: 'MIDI in / out'},
      {label: 'Headphone jack', value: '1 x 1/4"'},
      {label: 'Input jack', value: '2 x 1/4" mono'},
      {label: 'Output jack', value: '1 x 1/4" L/L+R • 1 x 1/4" R'},
      {label: 'Microphone jack', value: '1 x 1/4"'},
      {label: 'Pedal', value: 'Sustain •  Expression'},
      {label: 'AMPLIFIER', value: '2 x 25 watt • 2 x 15 watt '},
      {label: 'SPEAKER', value: '2 x 12 cm • 2 x 3 cm'},
      {label: 'POWER', value: 'DC 15V'},
      {label: 'DIMENSIONS', value: '39.65 x 15.43 x 5.12 in / 1007 x 392 x 130 mm'},
      {label: 'WEIGHT', value: '21.16 lb / 9.6 kg'},
      {label: 'AVAILABLE COLOR', value: 'BK'},
    ]
  },
  MK200: {
    title: 'MK200',
    id: 'MK200',
    pic: MK200t2,
    pic2: MK200t1,
    pic3: MK200t3,
    docs: [{href: MK200Doc, size: '2MB', afterfix: "OWNER'S MANUAL"}],
    detailPicList: [MK200D1, MK200D2, MK200D3, MK200D4, MK200D5, MK200D6],
    desc: 'The Medeli MK200 portable keyboard gives beginning students or music makers on the go a feature-rich instrument that is affordable, fun to practice on, and supports musical exploration and creativity. ',
    sp1: {
      text: '61 touch-sensitive piano style keys help beginners develop dynamic control and proper finger technique.',
      pic: MK2001
    },
    sp2: {
      text: '585 built-in instrument Sounds and 202 accompaniment Styles provide a wide variety of content for musical fun and exploration.',
      pic: MK2003
    },
    sp3: {
      text: '157 preset songs are included for listening or use with the Music Tutorial System, supplementing formal lessons and broadening any student’s musical horizons.',
      pic: MK2004
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: MK2005, desc: 'Connect headphones for a private playing experience or show off your accomplishments to friends and family through the built-in stereo speaker system. ' },
      { title: 'SELLING POINT 2', pic: MK2005, desc: 'USB MIDI makes connecting with learning and creative apps on your PC or smart device simple and easy.' },
      { title: 'SELLING POINT 3', pic: MK2005, desc: 'Power with the included AC adapter or use batteries for ultra-portable music making anywhere and anytime inspiration strikes.' },
    ],
    banners: [{pic: MK200t1}, {pic: MK200t1}],
    params: [
      {label: 'KEYBOARD', value: '61 keys (touch-sensitive)'},
      {label: 'DISPLAY', value: 'Backlit LCD'},
      {label: 'MAX POLYPHONY', value: '64'},
      {label: 'SOUND / VOICE', value: '585'},
      {label: 'STYLE', value: '202'},
      {label: 'DEMO SONG', value: '157'},
      {label: 'MUSIC LIBRARY', value: ['157 songs', 'Music Tutorial System']},
      {label: 'LAYER / SPLIT', value: 'L • R1 • R2'},
      {label: 'DUO (TWINOVA) ', value: ''},
      {label: 'STYLE CONTROL', value: [
        'Start / Stop',
        'Sync start',
        'Intro / Ending',
        'Main A / Fill in A',
        'Main B / Fill in B',
        'Chord mode',
        'Fade in / out'
      ]},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: '32'},
      {label: 'REVERB', value: '10 types • 33 levels'},
      {label: 'CHORUS', value: '8 types • 33 levels'},
      {label: 'EFFECT', value: 'DSP on / off'},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: 'Yes'},
      {label: 'SEQUENCER', value: '1 user song'},
      {label: 'PERFORMANCE MEMORY', value: '4 x 8 banks '},
      {label: 'Q.S. / O.T.S.', value: 'Yes'},
      {label: 'PERFORMANCE ENHANCEMENT', value: 'Arpeggiator'},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: 'Yes'},
      {label: 'PITCH ADJUSTMENT', value: [
        'Transpose',
        'Octave',
        'Tuning'
      ]},
      {label: 'METRONOME', value: 'Yes'},
      {label: 'TEMPO', value: '5-280'},
      {label: 'OTHER CONTROL', value: [
        'Touch sensitive',
        'Sustain',
        'Piano mode',
        'Chord dictionary'
      ]},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-B (MIDI)'},
      {label: 'MIDI', value: ''},
      {label: 'Headphone jack', value: '1 x 1/4" (headphone/output)'},
      {label: 'Input jack', value: '1 x 1/4"'},
      {label: 'Output jack', value: ''},
      {label: 'Microphone jack', value: '1 x 1/4"'},
      {label: 'Pedal', value: 'Sustain'},
      {label: 'AMPLIFIER', value: '2 x 2.5 watt'},
      {label: 'SPEAKER', value: '2 x 12 cm'},
      {label: 'POWER', value: 'DC 12V • 6 x AA batteries'},
      {label: 'DIMENSIONS', value: '37.24 x 12.44 x 3.98 in / 946 x 316 x 101 mm'},
      {label: 'WEIGHT', value: '8.82 lb / 4kg'},
      {label: 'AVAILABLE COLOR', value: 'BK'},
    ]
  },
  MK61: {
    title: 'MK61',
    id: 'MK61',
    pic: MK61t2,
    pic2: MK61t1,
    pic3: MK61t3,
    docs: [{href: MK61Doc, size: '0.9MB', afterfix: "OWNER'S MANUAL"}],
    detailPicList: [MK61D1, MK61D2, MK61D3, MK61D4, MK613, MK61D6, MK611, MK614],
    desc: 'The Medeli MK61 portable keyboard is an ideal starter instrument for piano students or creatives on a budget. Packed with Sounds, Styles and fun features, this instrument delivers!',
    sp1: {
      text: '61 touch-sensitive piano style keys help beginners develop dynamic control and proper finger technique. ',
      pic: MK616
    },
    sp2: {
      text: '450 built-in instrument Sounds and 150 accompaniment Styles provide a wide variety of content for musical fun and exploration.',
      pic: MK611
    },
    sp3: {
      text: '120 preset songs are included for listening or use with the Music Tutorial System, supplementing formal lessons and broadening any student’s musical horizons.',
      pic: MK612
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: MK613, desc: 'Connect headphones for a private playing experience or show off your accomplishments to friends and family through the built-in stereo speaker system.' },
      { title: 'SELLING POINT 2', pic: MK614, desc: 'USB MIDI makes connecting with learning and creative apps on your PC or smart device simple and easy.' },
      { title: 'SELLING POINT 3', pic: MK615, desc: 'Power with the included AC adapter or use batteries for ultra-portable music making anywhere and anytime inspiration strikes.' },
    ],
    // banners: [{pic: MK61t1}, {pic: MK61t1}],
    params: [
      {label: 'KEYBOARD', value: '61 keys (touch-sensitive)'},
      {label: 'DISPLAY', value: 'Backlit LCD'},
      {label: 'MAX POLYPHONY', value: '32'},
      {label: 'SOUND / VOICE', value: '450'},
      {label: 'STYLE', value: '150'},
      {label: 'DEMO SONG', value: '1'},
      {label: 'MUSIC LIBRARY', value: ['120 songs', 'Music tutorial system']},
      {label: 'LAYER / SPLIT', value: 'L • R1 • R2'},
      {label: 'DUO (TWINOVA) ', value: ''},
      {label: 'STYLE CONTROL', value: [
        'Start / Stop',
        'Sync start',
        'Intro / Ending',
        'A / B (A / B fill)',
        'Chord mode',
        'Fade in / out'
      ]},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: '32'},
      {label: 'REVERB', value: '10 levels'},
      {label: 'CHORUS', value: ''},
      {label: 'EFFECT', value: 'D.A.S.'},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: ''},
      {label: 'SEQUENCER', value: ''},
      {label: 'PERFORMANCE MEMORY', value: ''},
      {label: 'Q.S. / O.T.S.', value: ''},
      {label: 'PERFORMANCE ENHANCEMENT', value: ''},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: ''},
      {label: 'PITCH ADJUSTMENT', value: [
        'Transpose',
        'Octave',
        'Tuning'
      ]},
      {label: 'METRONOME', value: '0, 2-16'},
      {label: 'TEMPO', value: '5-320'},
      {label: 'OTHER CONTROL', value: [
        'Touch sensitive',
        'Sustain',
        'Speaker mode'
      ]},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-B (MIDI & Audio)'},
      {label: 'MIDI', value: ''},
      {label: 'Headphone jack', value: '1 x 1/8"'},
      {label: 'Input jack', value: ''},
      {label: 'Output jack', value: ''},
      {label: 'Microphone jack', value: ''},
      {label: 'Pedal', value: 'Sustain'},
      {label: 'AMPLIFIER', value: '2 x 2.5 watt'},
      {label: 'SPEAKER', value: '2 x 12 cm'},
      {label: 'POWER', value: 'DC 12V • 6 x AA batteries'},
      {label: 'DIMENSIONS', value: '36.06 x 12.01 x 3.62 in / 916 x 305 x 92 mm'},
      {label: 'WEIGHT', value: '7.72 lb / 3.5 kg'},
      {label: 'AVAILABLE COLOR', value: 'SB, BW, SY'},
    ]
  },
  MK37: {
    title: 'MK37',
    id: 'MK37',
    pic: MK37t2,
    pic2: MK37t1,
    pic3: MK37t3,
    docs: [{href: MK37Doc, size: '0.2MB', afterfix: "OWNER'S MANUAL"}],
    detailPicList: [MK37D1,MK37D2,MK37D3,MK37D4,MK37D5,MK37D6],
    desc: 'The Medeli MK37 mini-key portable keyboard fits in your backpack for music making on the go, and is perfectly sized for the little musicians in your life that are starting to show their love of music.',
    sp1: {
      text: '37 mini keys are perfect for little hands and help make this instrument ultra-portable and compact.',
      pic: MK371
    },
    sp2: {
      text: '200 built-in instrument Sounds and 120 accompaniment Styles provide a wide variety of content for musical fun and exploration. Use AutoChord to control Styles and free your hands to play melodies! ',
      pic: MK372
    },
    sp3: {
      text: '100 preset songs are included for listening enjoyment or use the Melody Off feature when learning or practicing playing along.',
      pic: MK373
    },
    // stickyList: [
    //   { title: 'SELLING POINT 1', pic: MK37t1, desc: 'The built-in USB MIDI and Audio interface means with only one cable your MK37 can connect with PCs or smart devices to interact with various learning or creative apps. Record to your software and listen back through the instrument’s speakers or headphones. ' },
    //   { title: 'SELLING POINT 2', pic: MK37t1, desc: 'Connect headphones for a private playing experience or perform for friends and family through the built-in speaker system. ' },
    //   { title: 'SELLING POINT 3', pic: MK37t1, desc: ' Power via USB-C or use batteries for ultra-portable music making anywhere and anytime inspiration strikes.' },
    // ],
    // banners: [{pic: MK37t1}, {pic: MK37D3}],
    params: [
      {label: 'KEYBOARD', value: '37 keys (mini-size)'},
      {label: 'DISPLAY', value: '3-digits LED'},
      {label: 'MAX POLYPHONY', value: '64'},
      {label: 'SOUND / VOICE', value: '200'},
      {label: 'STYLE', value: '120'},
      {label: 'DEMO SONG', value: ''},
      {label: 'MUSIC LIBRARY', value: ['100 songs', 'Melody off']},
      {label: 'LAYER / SPLIT', value: ''},
      {label: 'DUO (TWINOVA) ', value: ''},
      {label: 'STYLE CONTROL', value: ['Start / Stop', 'Sync start (Function)', 'A / B', 'Auto / Chord mode']},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: ''},
      {label: 'REVERB', value: '10 levels'},
      {label: 'CHORUS', value: ''},
      {label: 'EFFECT', value: ''},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: ''},
      {label: 'SEQUENCER', value: ''},
      {label: 'PERFORMANCE MEMORY', value: ''},
      {label: 'Q.S. / O.T.S.', value: ''},
      {label: 'PERFORMANCE ENHANCEMENT', value: ''},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: ''},
      {label: 'PITCH ADJUSTMENT', value: [
        'Transpose',
        'Octave',
        'Tuning'
      ]},
      {label: 'METRONOME', value: 'Yes'},
      {label: 'TEMPO', value: '5-320'},
      {label: 'OTHER CONTROL', value: 'Sustain'},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-C (MIDI & Audio)'},
      {label: 'MIDI', value: ''},
      {label: 'Headphone jack', value: '1 x 1/8"'},
      {label: 'Input jack', value: ''},
      {label: 'Output jack', value: ''},
      {label: 'Microphone jack', value: ''},
      {label: 'Pedal', value: ''},
      {label: 'AMPLIFIER', value: '2.5 watt'},
      {label: 'SPEAKER', value: '1 x 8 cm'},
      {label: 'POWER', value: 'USB-C 5V • 4 x AA batteries'},
      {label: 'DIMENSIONS', value: '19.29 x 7.32 x 2.36 in / 490 x 186 x 60 mm'},
      {label: 'WEIGHT', value: '2.38 lb / 1.08 kg'},
      {label: 'AVAILABLE COLOR', value: 'PO'},
    ]
  },
  MK49: {
    title: 'MK49',
    id: 'MK49',
    pic: MK49p5,
    pic2: mk49Banner,
    pic3: MK49p5,
    docs: [{href: MK49Doc, size: '1MB', afterfix: "OWNER'S MANUAL"}],
    // detailPicList: [MK37D1,MK37D2,MK37D3,MK37D4,MK37D5,MK37D6],
    desc: 'The Medeli MK49 mini-key portable keyboard provides budding musicians and creators on-the-go with an expressive, fun and versatile musical companion that’s ready to help you learn and create anywhere, anytime.',
    sp1: {
      text: '49 touch-sensitive mini keys are perfect for growing hands and intuitively playable by those more familiar with full-sized keys.',
      pic: MK49p3
    },
    sp2: {
      text: '200 built-in instrument Sounds and 120 accompaniment Styles provide a wide variety of content for musical fun and exploration. Use AutoChord to control Styles and free your hands to play melodies!',
      pic: MK49p4
    },
    sp3: {
      text: 'The built-in USB MIDI and Audio interface means with only one cable your MK49 can connect with PCs or smart devices to interact with various learning or creative apps. Record to your software and listen back through the instrument’s stereo speakers or headphones.',
      pic: MK49p2
    },
    stickyList: [
      { title: 'SELLING POINT 1', pic: MK49p1, desc: '100 preset songs are included for listening enjoyment or use the Melody Off feature when learning or practicing playing along.' },
      { title: 'SELLING POINT 2', pic: MK49p2, desc: 'Connect headphones for a private playing experience or perform for friends and family through the built-in speaker system.' },
      { title: 'SELLING POINT 3', pic: MK49p2, desc: 'Power via USB-C or use batteries for ultra-portable music making anywhere and anytime inspiration strikes.' },
    ],
    params: [
      {label: 'KEYBOARD', value: '49 keys (mini-size,touch-sensitive)'},
      {label: 'DISPLAY', value: 'Backlit LCD'},
      {label: 'MAX POLYPHONY', value: '64'},
      {label: 'SOUND / VOICE', value: '200'},
      {label: 'STYLE', value: '120'},
      {label: 'DEMO SONG', value: ''},
      {label: 'MUSIC LIBRARY', value: ['100 songs', 'Music tutorial system']},
      {label: 'LAYER / SPLIT', value: ''},
      {label: 'DUO (TWINOVA) ', value: ''},
      {label: 'STYLE CONTROL', value: [
        'Start / Stop',
        'Sync / Fill',
        'Intro / Ending',
        'A / B (A / B fill)',
        'Auto / Chord mode'
      ]},
      {label: 'STYLE CREATOR', value: ''},
      {label: 'CHORD TYPE', value: '32'},
      {label: 'REVERB', value: '128 levels'},
      {label: 'CHORUS', value: '128 levels'},
      {label: 'EFFECT', value: 'DSP on / off'},
      {label: 'MASTER EQ', value: ''},
      {label: 'MIXER', value: ''},
      {label: 'SEQUENCER', value: ''},
      {label: 'PERFORMANCE MEMORY', value: '4 memories'},
      {label: 'Q.S. / O.T.S.', value: 'Yes'},
      {label: 'PERFORMANCE ENHANCEMENT', value: ''},
      {label: 'AUDIO PLAYBACK', value: ''},
      {label: 'AUDIO RECORDER', value: ''},
      {label: 'SCORE DISPLAY', value: ''},
      {label: 'ASSIGNABLE CONTROLLER', value: ''},
      {label: 'PITCHBEND', value: ''},
      {label: 'MODULATION', value: ''},
      {label: 'PITCH ADJUSTMENT', value: [
        'Transpose',
        'Octave',
        'Tuning'
      ]},
      {label: 'METRONOME', value: 'Yes'},
      {label: 'TEMPO', value: '5-320'},
      {label: 'OTHER CONTROL', value: [
        'Touch sensitive',
        'Sustain',
        'Chord reference'
      ]},
      {label: 'EXTERNAL DRIVE', value: ''},
      {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-C (MIDI & Audio)'},
      {label: 'MIDI', value: ''},
      {label: 'Headphone jack', value: '1 x 1/8"'},
      {label: 'Input jack', value: ''},
      {label: 'Output jack', value: ''},
      {label: 'Microphone jack', value: ''},
      {label: 'Pedal', value: 'Sustain'},
      {label: 'AMPLIFIER', value: '2 x 2.5 watt'},
      {label: 'SPEAKER', value: '2 x 9 cm'},
      {label: 'POWER', value: 'USB-C 5V • 4 x AA batteries'},
      {label: 'DIMENSIONS', value: '642 x 200 x 68 mm'},
      {label: 'WEIGHT', value: '1.78 kg'},
      {label: 'AVAILABLE COLOR', value: 'SB'},
    ]
  },
  MR101S: {
    title: 'MR101S',
    id: 'MR101S',
    pic: MR1010St2,
    pic2: MR1010St10,
    video: 'https://medeli-us.com/video/MR101S.mp4',
    videoCover: MR1010St11,
    docs: [],
    desc: 'The Medeli MR101S is a no-nonsense, portable drummer designed for solo performers looking to spice up their live sets with drumbeats and for musicians wanting a break from practicing with a traditional metronome.',
    sp1: {
      text: '48 drum kits and 100 preset drum patterns cover a huge range of music genres, plus you can record and save up to 100 of your own patterns, making MR101S nearly limitless. ',
      pic: MR1010St11
    },
    sp2: {
      text: 'Use Swing control to add feel and groove to the built-in patterns or your own recorded patterns.',
      pic: MR1010St4
    },
    sp3: {
      text: 'The included foot pedal gives you hands-free flexibility to trigger fills, play sounds, tap the desired tempo and start or stop pattern play. ',
      pic: MR1010St5
    },
    sp4: 'Built-in stereo speakers are perfect for working on your beats without the need for headphones or an amplifier.',
    stickyList: [
      { title: 'SELLING POINT 1', pic: MR1010St6, desc: 'Send and receive MIDI and Audio via USB-C for seamless integration with home studio software or creative apps on the go. ' },
      { title: 'SELLING POINT 2', pic: MR1010St8, desc: 'Compact and lightweight, MR101S supports battery power (or power via USB-C), giving you the flexibility to bring your personal drummer anywhere you want to make music. ' },
      { title: 'SELLING POINT 3', pic: MR1010St7, desc: '16 touch-sensitive drum pads light up when played, and let you finger-drum in real time, or record your own beats with ease. ' },
      { title: 'SELLING POINT 4', pic: MR1010St9, desc: 'Connect headphones to rock out in privacy or use the line output to plug into external amplification or studio equipment.' },
      { title: 'SELLING POINT 5', pic: MR1010St12, desc: 'Built-in stereo speakers are perfect for working on your beats without the need for headphones or an amplifier.' },
    ],
    unCompile: true,
    banners: [{pic: MR1010St1}, {pic: MR1010St3}, {pic:MR1010St4}, {pic: MR1010St5}],
    params: [
      {label: 'DRUM PAD', value: '16 finger pads (touch-sensitive)'},
      // {label: 'SWITCH PEDAL', value: ''},
      {label: 'DISPLAY', value: '0.96" (128 x 64) OLED'},
      {label: 'DRUM KIT', value: '48'},
      {label: 'SOUND / VOICE', value: '185'},
      {label: 'SONG', value: '50 users'},
      {label: 'RHYTHM', value: '100 preset + 100 user'},
      // {label: 'DEMO', value: ''},
      // {label: 'Bluetooth', value: ''},
      {label: 'USB', value: '1 x USB-C (MIDI & Audio)'},
      {label: 'headphone / output jack', value: ['1 x 1/8” headphone', '1 x1/4"  line output']},
      // {label: 'aux-in jack', value: ''},
      {label: 'Pedal', value: '1/4 (pedal included)'},
      // {label: 'LEARNING', value: ''},
      // {label: 'GAME', value: ''},
      {label: 'RECORD', value: 'Yes'},
      {label: 'TEMPO', value: '5-320'},
      {label: 'EFFECT', value: ['Reverb']},
      {label: 'PANEL CONTROL', value: [
        'Power',
        'Volume',
        'Tempo/Value',
        'Rhythm',
        'Kit',
        'Song/Pattern',
        'Playhead/Erase',
        'Record/Enter',
        'Start/Stop',
        'Fill/Function',
        'Tap Tempo'
      ]},
      // {label: 'OTHER', value: ''},
      {label: 'POWER', value: ['USB-C 5V (1000mA)', 'cable included']},
      {label: 'DIMENSIONS', value: '7.17 x 4.39 x 2.26 in / 182 x 111.5 x 57.5 mm'},
      {label: 'WEIGHT', value: '1.01 lb / 0.46 kg'},
      
    ]
  },
  tp110: {
    title: 'TP110',
    id: 'tp110',
    pic: TP110p7,
    pic2: TP110p4,
    // video: 'https://medeli-us.com/video/MR101S.mp4',
    // videoCover: MR1010St11,
    docs: [{href: TP110Doc, size: '3.16MB', afterfix: "OWNER'S MANUAL"}],
    desc: 'The TP110 Pro Coach is an electronic practice pad system with a unique combination of features not found in any other product. From beginners to top professionals, the TP110 Pro Coach is a smarter way to improve and accelerate the development of your drumming skills that you can do anywhere and anytime.',
    sp1: {
      text: 'A 10” mesh pad paired with 55 dynamic drum and percussion sounds delivers a realistic and inspiring practice experience. The sound library includes marching, field, concert, and drum set snares, along with bass drums, toms, cymbals, concert and Latin percussion, and electronic drum sounds.',
      pic: TP110p1
    },
    sp2: {
      text: 'The advanced metronome features a human voice count and supports time signatures up to 17 beats per measure, with beat subdivisions including quintuplets and sextuplets—making it rare to find a piece of music the Pro Coach can’t handle.',
      pic: TP110p2
    },
    sp3: {
      text: 'The six built-in Coach exercises are designed to develop essential drumming skills and challenge players at any level. Improve your timing with Beat Check and Quiet Count, enhance articulation and consistency with Stroke Balance and Change Up, build speed with Gradual Up/Down, and test your endurance in Speed Challenge by playing as many single strokes as possible within a set time.',
      pic: TP110p3
    },
    // sp4: 'Built-in stereo speakers are perfect for working on your beats without the need for headphones or an amplifier.',
    // stickyList: [
    //   { title: 'SELLING POINT 1', pic: MR1010St6, desc: 'Send and receive MIDI and Audio via USB-C for seamless integration with home studio software or creative apps on the go. ' },
    //   { title: 'SELLING POINT 2', pic: MR1010St8, desc: 'Compact and lightweight, MR101S supports battery power (or power via USB-C), giving you the flexibility to bring your personal drummer anywhere you want to make music. ' },
    //   { title: 'SELLING POINT 3', pic: MR1010St7, desc: '16 touch-sensitive drum pads light up when played, and let you finger-drum in real time, or record your own beats with ease. ' },
    //   { title: 'SELLING POINT 4', pic: MR1010St9, desc: 'Connect headphones to rock out in privacy or use the line output to plug into external amplification or studio equipment.' },
    //   { title: 'SELLING POINT 5', pic: MR1010St12, desc: 'Built-in stereo speakers are perfect for working on your beats without the need for headphones or an amplifier.' },
    // ],
    unCompile: true,
    banners: [{pic: TP110p8}, {pic: TP110p9}, {pic:TP110p6}, {pic: TP110p7}],
    params: [
      {label: 'DRUM PAD', value: '1 pad (10" mesh head • sensitivity • head tension)'},
      {label: 'SWITCH PEDAL', value: '-'},
      {label: 'DISPLAY', value: '3" (128 x 64) LCD'},
      {label: 'DRUM KIT', value: '-'},
      {label: 'SOUND / VOICE', value: '55'},
      {label: 'SONG', value: '-'},
      {label: 'RHYTHM', value: '-'},
      {label: 'DEMO', value: '-'},
      {label: 'Bluetooth', value: 'Audio'},
      {label: 'USB', value: '1 x USB-C'},
      {label: 'headphone / output jack', value: '1 x 1/8"'},
      {label: 'aux-in jack', value: '-'},
      {label: 'Pedal', value: '-'},
      {label: 'LEARNING', value: 'Coach function'},
      {label: 'GAME', value: '-'},
      {label: 'RECORD', value: '-'},
      {label: 'TEMPO', value: '20-300'},
      {label: 'EFFECT', value: '…'},
      {label: 'PANEL CONTROL', value: [
        'Power',
        'Start/Stop',
        'Mode/Dial',
        'Volume',
        '+/-',
      ]},
      {label: 'OTHER', value: [ 'Click', '1 x TRS trigger input' ]},
      {label: 'POWER', value: ['USB-C 5V (1000mA) ', '4 x AA batteries']},
      {label: 'DIMENSIONS', value: '300.8 x 360 x 67.5 mm'},
      {label: 'WEIGHT', value: '1.48 kg'},
      
    ]
  }
}

const data = [
  {
    category: 'DigitalPianos',
    name: 'Digital Pianos',
    pic: spc1212,
    title: productMap.SPC121.title,
    items: [
      { 
        id: 'PortablePIANOS', 
        label: 'PORTABLE PIANOS', 
        desc: 'Modern aesthetic, classic piano experience,wherever you make music.',
        pic: p4Pic,
        pic2: productMap.SPC121.pic,
        items: [
          productMap.SP201Plus,
          productMap.SPC121,
        ]
      },
      { 
        id: 'COMPACTPIANOS', 
        label: 'COMPACT PIANOS', 
        desc: 'Traditional style, slim design',
        pic: p1Pic,
        pic2: productMap.CP203.pic,
        items: [
          productMap.CP203
        ]
      }
    ]
  },
  {
    category: 'Keyboards',
    name: 'Keyboards',
    pic: AKX10S2,
    title: productMap.AKX10S.title,
    items: [
      {
        id: 'ARRANGERKEYBOARDS',
        label: 'ARRANGER KEYBOARDS',
        desc: '',
        pic: AKX10S2,
        pic2: productMap.AKX10S.pic,
        items: [
          productMap.AKX10S
        ]
      },
      { 
        id: 'PORTABLEKEYBOARDS', 
        label: 'PORTABLE KEYBOARDS', 
        desc: '',
        pic: MK2002,
        pic2: productMap.MK200.pic,
        items: [
          // productMap.MK200,
          productMap.MK61,
          productMap.MK37,
          productMap.MK49
        ]
      }
    ]
  },
  {
    category: 'Drums',
    name: 'Drums',
    pic: MR101S2,
    title: productMap.MR101S.title,
    items: [
      { 
        id: 'RHYTHMMACHINE', 
        label: 'RHYTHM MACHINES', 
        desc: '',
        pic: p3Pic,
        pic2: productMap.MR101S.pic,
        items: [
          productMap.MR101S,
        ]
      },
      { 
        id: 'PORTABLEDRUM', 
        label: 'PORTABLE DRUM', 
        desc: '',
        pic: TP110p5,
        pic2: productMap.tp110.pic,
        items: [
          productMap.tp110
        ]
      },
    ]
  }
]

export default data
